import ShipmentsContainer from '@components/containers/shipments';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const Shipments: FC = () => (
    <AppLayout>
        <ShipmentsContainer />
    </AppLayout>
);

export default Shipments;
